import React, { Component } from 'react';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from 'dwomuster/muster/react';

class BacklinkWrapper extends Component {
  // onBacklinkClicked => callback function
  //removeOverride => property True/False 
  constructor(props) { super(props); }
  render = () => { 
    return ( 
      <View style={{
        flex: 1
      }}>
        {this.props.children}
      </View>
    )
  };



  componentDidUpdate(prevProps, prevState, snapshot){
   
    if(  prevProps.ui.backlink.onClicked !== this.props.ui.backlink.onClicked){
      // trigger callback!
      if(!this.props.removeOverride ){
        this.props.onBacklinkClicked();
      }else{
        this.props.ui.history.back();
      }
     
    }
  }
    
  componentDidMount(){
    this.props.ui.backlink.isDisable(true);
  }
}

export default  createContainer(
  {
    $queries: {
      ui:{
        history: {
          back: { $call: 'goBack' }
        },
        backlink:{
          onClicked: true,
          isDisable: {$set : 'isDisable'}
        }
      }
    }
  })(BacklinkWrapper);